import { render, staticRenderFns } from "./SizeForm.vue?vue&type=template&id=81dffc00&"
import script from "./SizeForm.vue?vue&type=script&lang=js&"
export * from "./SizeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports